import React, { useState } from 'react';
import { ArrowLeftIcon, ImageIcon, MapPinIcon, TagIcon, UsersIcon, XIcon, SparklesIcon } from 'lucide-react';
import Avatar from '../components/shared/Avatar';
import Button from '../components/shared/Button';
const CreatePostPage = () => {
  const [caption, setCaption] = useState('');
  const [selectedImages, setSelectedImages] = useState<string[]>([]);
  const [location, setLocation] = useState('');
  const [tags, setTags] = useState<string[]>([]);
  const [tagInput, setTagInput] = useState('');
  const handleAddTag = () => {
    if (tagInput && !tags.includes(tagInput)) {
      setTags([...tags, tagInput]);
      setTagInput('');
    }
  };
  const handleRemoveTag = (tagToRemove: string) => {
    setTags(tags.filter(tag => tag !== tagToRemove));
  };
  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      const newImages = Array.from(files).map(file => URL.createObjectURL(file));
      setSelectedImages([...selectedImages, ...newImages]);
    }
  };
  const handleRemoveImage = (index: number) => {
    const newImages = [...selectedImages];
    newImages.splice(index, 1);
    setSelectedImages(newImages);
  };
  const user = {
    name: 'Lionel Messi',
    username: 'leomessi',
    avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d',
    verified: true,
    role: 'Player',
    sport: 'football'
  };
  return <div className="bg-white min-h-full pb-16" data-id="element-663">
      {/* Header */}
      <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200" data-id="element-664">
        <button className="text-gray-800" data-id="element-665">
          <ArrowLeftIcon size={24} data-id="element-666" />
        </button>
        <h1 className="text-lg font-semibold" data-id="element-667">Create Post</h1>
        <Button variant="primary" size="sm" disabled={!caption || selectedImages.length === 0} data-id="element-668">
          Share
        </Button>
      </div>
      {/* User Info */}
      <div className="flex items-center px-4 py-3" data-id="element-669">
        <Avatar src={user.avatar} size="md" sport={user.sport} data-id="element-670" />
        <div className="ml-3" data-id="element-671">
          <div className="flex items-center" data-id="element-672">
            <span className="font-semibold text-sm" data-id="element-673">{user.username}</span>
            {user.verified && <svg className="w-3 h-3 text-blue-500 ml-1" fill="currentColor" viewBox="0 0 20 20" data-id="element-674">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-675"></path>
              </svg>}
          </div>
          <div className="text-xs text-gray-500" data-id="element-676">
            <span data-id="element-677">{user.role}</span>
            <span className="mx-1" data-id="element-678">•</span>
            <span data-id="element-679">{user.sport}</span>
          </div>
        </div>
      </div>
      {/* Caption Input */}
      <div className="px-4 py-2" data-id="element-680">
        <textarea placeholder="Write a caption..." value={caption} onChange={e => setCaption(e.target.value)} className="w-full border-none outline-none resize-none h-20 text-sm" data-id="element-681" />
      </div>
      {/* Image Upload */}
      <div className="px-4 py-2 border-t border-gray-100" data-id="element-682">
        {selectedImages.length === 0 ? <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 flex flex-col items-center" data-id="element-683">
            <ImageIcon size={36} className="text-gray-400 mb-2" data-id="element-684" />
            <p className="text-gray-500 text-sm text-center mb-3" data-id="element-685">
              Upload photos or videos
            </p>
            <label htmlFor="file-upload" className="cursor-pointer" data-id="element-686">
              <div className="bg-blue-600 text-white text-sm font-medium px-4 py-2 rounded-lg" data-id="element-687">
                Select from device
              </div>
              <input id="file-upload" type="file" multiple accept="image/*,video/*" className="hidden" onChange={handleImageUpload} data-id="element-688" />
            </label>
          </div> : <div data-id="element-689">
            <div className="grid grid-cols-3 gap-2" data-id="element-690">
              {selectedImages.map((img, index) => <div key={index} className="aspect-square relative" data-id="element-691">
                  <img src={img} alt={`Upload ${index + 1}`} className="w-full h-full object-cover rounded-lg" data-id="element-692" />
                  <button className="absolute top-1 right-1 bg-black bg-opacity-50 rounded-full p-1" onClick={() => handleRemoveImage(index)} data-id="element-693">
                    <XIcon size={14} className="text-white" data-id="element-694" />
                  </button>
                </div>)}
              <label htmlFor="add-more-files" className="aspect-square border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center cursor-pointer" data-id="element-695">
                <ImageIcon size={24} className="text-gray-400" data-id="element-696" />
                <input id="add-more-files" type="file" multiple accept="image/*,video/*" className="hidden" onChange={handleImageUpload} data-id="element-697" />
              </label>
            </div>
          </div>}
      </div>
      {/* Additional Options */}
      <div className="px-4 py-4 space-y-4 border-t border-gray-100 mt-4" data-id="element-698">
        {/* Location */}
        <div className="flex items-center" data-id="element-699">
          <MapPinIcon size={20} className="text-gray-500 mr-3" data-id="element-700" />
          <input type="text" placeholder="Add location" value={location} onChange={e => setLocation(e.target.value)} className="flex-1 border-none outline-none text-sm" data-id="element-701" />
        </div>
        {/* Tags */}
        <div className="flex items-center" data-id="element-702">
          <TagIcon size={20} className="text-gray-500 mr-3" data-id="element-703" />
          <div className="flex-1" data-id="element-704">
            <div className="flex flex-wrap mb-2" data-id="element-705">
              {tags.map((tag, index) => <div key={index} className="bg-gray-100 rounded-full px-2 py-1 text-xs flex items-center mr-1 mb-1" data-id="element-706">
                  <span className="text-blue-600" data-id="element-707">{tag}</span>
                  <button className="ml-1 text-gray-500" onClick={() => handleRemoveTag(tag)} data-id="element-708">
                    <XIcon size={12} data-id="element-709" />
                  </button>
                </div>)}
            </div>
            <div className="flex" data-id="element-710">
              <input type="text" placeholder="Add tags" value={tagInput} onChange={e => setTagInput(e.target.value)} className="flex-1 border-none outline-none text-sm" onKeyPress={e => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleAddTag();
              }
            }} data-id="element-711" />
              <button className="text-blue-600 text-sm" onClick={handleAddTag} data-id="element-712">
                Add
              </button>
            </div>
          </div>
        </div>
        {/* Tag People */}
        <div className="flex items-center" data-id="element-713">
          <UsersIcon size={20} className="text-gray-500 mr-3" data-id="element-714" />
          <span className="text-sm text-gray-800" data-id="element-715">Tag people</span>
        </div>
      </div>
      {/* Post Type Options */}
      <div className="px-4 py-4 border-t border-gray-100" data-id="element-716">
        <h3 className="text-sm font-medium mb-3" data-id="element-717">Post Type</h3>
        <div className="grid grid-cols-2 gap-2" data-id="element-718">
          <button className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-center" data-id="element-719">
            <div className="bg-blue-100 w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-720">
              <ImageIcon size={20} className="text-blue-600" data-id="element-721" />
            </div>
            <span className="text-sm font-medium" data-id="element-722">Standard Post</span>
          </button>
          <button className="bg-purple-50 border border-purple-200 rounded-lg p-3 text-center" data-id="element-723">
            <div className="bg-purple-100 w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-724">
              <SparklesIcon size={20} className="text-purple-600" data-id="element-725" />
            </div>
            <span className="text-sm font-medium" data-id="element-726">Generate Content</span>
            <p className="text-xs text-purple-600 mt-1" data-id="element-727">
              Banners • Lineups • Profiles
            </p>
          </button>
        </div>
      </div>
    </div>;
};
export default CreatePostPage;